import React, {useState, useEffect} from 'react'
import { useNavigate, useLocation  } from 'react-router-dom';
import { useAuthState } from "react-firebase-hooks/auth";
import { auth, getUserByUid } from '../firebase';
import LoadingSpinner from '../components/LoadingSpinner';

function ProtectedRoute ({ Page, redirectIfLoggedIn = false, fetchIsAdmin = false }) {
    const [user, loading, error] = useAuthState(auth);
    const [done, setDone] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        setDone(false);
        const fetchAdmin = async () => {
            const userDoc = await getUserByUid(user.uid);
            setIsAdmin(userDoc.isAdmin);
        }
        if (loading) return;
        if (error) alert('Something went wrong. Please try again.');
        if (user && redirectIfLoggedIn) return navigate("/");
        if (!user && !redirectIfLoggedIn) return navigate("/login");
        
        if (user && fetchIsAdmin) { fetchAdmin().then(() => setDone(true));}
        else setDone(true);
    }, [user, loading, error, redirectIfLoggedIn, navigate, fetchIsAdmin]);

    useEffect(() => {
        if (!isAdmin && done && location.pathname === '/admins') {
          navigate('/unauthorized');
        }
      }, [location.pathname, isAdmin, navigate, done]);
    
    return (
        <>
            {!done ? <LoadingSpinner isLoading={true}/> : <Page user={user} isAdmin={isAdmin}/>}
        </>
    )
}


export default ProtectedRoute